import { Fancybox } from "@fancyapps/ui";

import Swiper, { Navigation, Thumbs } from "swiper"
Swiper.use([Navigation, Thumbs])

export default new (class CertificateGallery {
    constructor() {
        this.certificateContainerSelectorMain = "certificate-wrap"
        this.sliderGalleryPreview = '[data-fancybox="gallery"]:not(.swiper-slide-duplicate)'
        this.handler()
    }

    handler() {
        const certificateContainerSelectorMain = document.querySelector(`.${this.certificateContainerSelectorMain}`)

        if (!certificateContainerSelectorMain) return

        document.addEventListener("DOMContentLoaded", () => {
            this.initFancybox()
        })
    }

    initFancybox() {
        Fancybox.bind(`${this.sliderGalleryPreview}`, {
            groupAll: true,
            infinite: false,
            placeFocusBack: true,
            animated: false,
            closeButton: "outside",
            mainClass: "fancybox-custom",
            showClass: false,
            hideClass: false,
            template : {
                main: '<div class="fancybox__container" role="dialog" aria-modal="true" aria-hidden="true" aria-label="{{MODAL}}" tabindex="-1"><div class="fancybox__backdrop"></div><div class="fancybox-custom-parent"><div class="fancybox__carousel"></div></div></div>'
            },
            on: {
                ready: (fancybox) => {
                    if(document.querySelector('.can-zoom_in')) {
                        document.querySelectorAll('.can-zoom_in').forEach(element => {
                            element.classList.remove(can-zoom_in);
                        });
                    }
                    if(fancybox.items.length > 1) {
                        document.querySelector('.carousel__button.is-next').innerHTML = '<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><circle r="30" transform="matrix(1 0 0 -1 30 30)" fill="#253642" fill-opacity="0.6"/><path d="M26 19.3334L36.6667 30L26 40.6667" stroke="white" stroke-width="2" stroke-linecap="round"/></svg>'
                        document.querySelector('.carousel__button.is-prev').innerHTML = '<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><circle r="30" transform="matrix(-1 0 0 1 30 30)" fill="#253642" fill-opacity="0.6"/><path d="M34 19.3334L23.3333 30L34 40.6667" stroke="white" stroke-width="2" stroke-linecap="round"/></svg>'
                    }
                    document.querySelector('.fancybox__button--close').innerHTML = '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M27 14.41L25.59 13L20 18.59L14.41 13L13 14.41L18.59 20L13 25.59L14.41 27L20 21.41L25.59 27L27 25.59L21.41 20L27 14.41Z" fill="#253642"/><rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#253642"/></svg>'
                },
            }
        });
    }
})()
